<template>
    <div class="space-y-2">
        <UInput
            type="number"
            size="lg"
            min="1"
            placeholder="Minimum"
            :model-value="filter.value"
            @update:model-value="onUpdate($event)"
        />
        <p class="text-xs text-gray-500">
            Customers whose app calls were switched to a non-member at least this many times.
        </p>
    </div>
</template>

<script setup lang="ts">
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

function onUpdate(raw: string) {
    const n = raw === '' || raw == null ? undefined : Math.max(1, Math.floor(Number(raw)))

    if (n == null || Number.isNaN(n)) {
        emit('update:filter', { ...props.filter, selected: undefined, value: undefined })
    } else {
        emit('update:filter', { ...props.filter, selected: n, value: n })
    }
}
</script>
